import { render, staticRenderFns } from "./change-order-status.vue?vue&type=template&id=b0038792&"
import script from "./change-order-status.vue?vue&type=script&lang=ts&"
export * from "./change-order-status.vue?vue&type=script&lang=ts&"
import style0 from "./change-order-status.vue?vue&type=style&index=0&id=b0038792&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports